import React from 'react';

import { Flex, FlexProps } from '@chakra-ui/react';

export default function Divider(props : FlexProps) {
  return (
    <Flex
      mt={7}
      right={12}
      position="relative"
      w="1024px"
      h="1px"
      bg="gray.50"
      {...props}
    />
  );
}
